import { useEffect } from 'react';
import eventEmitter from './event-emitter';

const useSubscribeToEmitterEvent = <DataType>(eventKey: string, someFunc: (data: DataType) => void) => {
  useEffect(() => {
    eventEmitter.on(eventKey, someFunc);

    return () => {
      eventEmitter.off(eventKey, someFunc);
    };
  }, [someFunc, eventKey]);
};

export default useSubscribeToEmitterEvent;
